import React from "react";

import cx from "classnames";

import { nGetText } from "~/lib/utils";

import styles from "./ViewEvent.module.css";

export default function AssignedActionItemsRow({ count }: { count?: number }) {
	if (!count) {
		return null;
	}

	return (
		<div className={styles.infoRow}>
			<div className={cx(styles.infoRow__icon, styles.centered)}>
				<div className={styles.checkboxIconWrapper}>
					<div className={styles.checkboxIcon} />
				</div>
			</div>
			<div className={cx(styles.infoRow__text, styles.textSmall, styles.secondaryText)}>
				{count} {nGetText(count, "action item", "action items")} assigned to you
			</div>
		</div>
	);
}
